import { ProfileFormData } from "./ProfileFormData";

export class MilitaryInfoFormData extends ProfileFormData {
    constructor(_applicantId: number, _pageId: string) {
        super(_applicantId, _pageId);
    }

    MilitaryStatus?: string;
    UsingGiBill?: string;
    GiBillBenefits?: string;
    TransferredBenefit?: string;
    TransferorName?: string;
    TuitionAssistanceExpected?: string;
    CurrentMilitaryStatus?: string;
    MilitaryBranch?: string;
    MilitaryRank?: string;
    MilitaryInstallation?: string;
    YearsOfService?: string;
    MilitaryRateMOS?: string;
    MilitaryTranscriptRequested?: string;
    CH33ExpectedPercentage?: string;
    MilitaryTranscriptDateRequested?: Date;
    IntendToUseMyCAA?: string;  // New field
    HasMilitarySpouse?: string;
    SpouseMilitaryStatus?: string;
    HasMilitaryParent?: string;
    ParentMilitaryStatus?: string;

    toJSON() {
        return {
            applicantId: this.applicantId,
            pageId: this.pageId,
            MilitaryStatus: this.MilitaryStatus,
            UsingGiBill: this.UsingGiBill,
            GiBillBenefits: this.GiBillBenefits,
            TransferredBenefit: this.TransferredBenefit,
            TransferorName: this.TransferorName,
            TuitionAssistanceExpected: this.TuitionAssistanceExpected,
            CurrentMilitaryStatus: this.CurrentMilitaryStatus,
            MilitaryBranch: this.MilitaryBranch,
            MilitaryRank: this.MilitaryRank,
            MilitaryInstallation: this.MilitaryInstallation,
            YearsOfService: this.YearsOfService,
            MilitaryRateMOS: this.MilitaryRateMOS,
            MilitaryTranscriptRequested: this.MilitaryTranscriptRequested,
            CH33ExpectedPercentage: this.CH33ExpectedPercentage,
            MilitaryTranscriptDateRequested: this.MilitaryTranscriptDateRequested,
            IntendToUseMyCAA: this.IntendToUseMyCAA,  // New field
            HasMilitarySpouse: this.HasMilitarySpouse,
            SpouseMilitaryStatus: this.SpouseMilitaryStatus,
            HasMilitaryParent: this.HasMilitaryParent,
            ParentMilitaryStatus: this.ParentMilitaryStatus,
        };
    }
}
